import { NL } from "./nl_NL"

/**
 * Type representing all valid internationalization keys
 */
export type IntlKey = keyof typeof NL

export const isIntlKey = (key: unknown): key is IntlKey => typeof key === "string" && key in NL

/**
 * The platform's own "no practices found" copy on the public search page, one
 * key per paragraph in reading order. The public page renders these, and the
 * care group settings show them as the default a care group's own message
 * replaces, so both sides must agree on exactly this list.
 */
export const PLATFORM_NO_RESULTS_KEYS = [
  "practiceSearch.searchZipCode.noResults",
  "practiceSearch.searchZipCode.noResults.clarification",
] as const satisfies readonly IntlKey[]
